module.exports = __webpack_public_path__ + "static/media/9.663c9d24.png";